<template>
  <div>
    <van-popup v-model="show" class="loginCss">
      <div class="signUpBox">
        <img
          src="@/assets/signUp/icons_close.png"
          alt
          class="close-icon"
          @click="
            () => {
              this.show = false
            }
          "
        >
        <div class="box-title">{{ tit_tip }}</div>
        <!-- <div class="line"></div> -->
        <div class="van-hairline--top"></div>
        <div class="register-box" v-show="resFlag">
          <div class="van-hairline--surround firstInput">
            <van-field
              v-model="resObj.username"
              clearable
              placeholder="输入至少6位数用户信息"
              :error="rule.user"
              required
              @blur="
                e => {
                  e.target.value.length < 6 ? (rule.user = true) : (rule.user = false)
                }
              "
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_user.png" alt>
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <van-field
              v-model="resObj.password"
              clearable
              placeholder="输入至少6位数登录密码"
              @blur="
                e => {
                  e.target.value.length < 6 ? (rule.psw = true) : (rule.psw = false)
                }
              "
              :error="rule.psw"
              required
              type="password"
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_psw.png" alt>
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <van-field
              v-model="resObj.password_confirmation"
              clearable
              placeholder="请二次输入密码"
              type="password"
              :error="rule.psw2"
              @blur="
                e => {
                  e.target.value == ''
                    ? (rule.psw2 = true)
                    : e.target.value !== resObj.password
                    ? (rule.psw2 = true)
                    : (rule.psw2 = false)
                }
              "
              required
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_psw.png" alt>
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <van-field
              v-model="resObj.phone"
              clearable
              rule.psw2
              :error="rule.phone"
              required
              placeholder="联系电话"
              @blur="
                e => {
                  ;/^1[34578]\d{9}$/.test(e.target.value) ? (rule.phone = false) : (rule.phone = true)
                }
              "
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_phone.png" alt>
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <select
              class="selectCss"
              placeholder="您通过什么渠道了解到我们"
              v-model="register_source"
              @change="changeSource"
            >
              <option value>您通过什么渠道了解到我们</option>
              <option :value="item.id" v-for="(item, i) in registerSource" :key="i">{{ item.name }}</option>
            </select>
          </div>
          <div class="van-hairline--surround" v-if="register_source === 13">
            <van-field v-model="register_source_detail" required placeholder="请输入其他来源渠道">
              <template slot="left-icon">
                <!-- <img src="@/assets/signUp/icons_phone.png" alt="" /> -->
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <select class="selectCss" placeholder="您更关注哪些方面产品" v-model="product_type">
              <option value style="color: #ff0000">您更关注哪些方面产品</option>
              <option :value="1">海外货盘</option>
              <option :value="2">国内货盘</option>
              <option :value="3">JIT</option>
              <option :value="4">SAAS</option>
            </select>
          </div>
          <div
            class="product-tip"
            style="width:100%; padding-left: 10px;margin-top: 2px;color:#666;font-size:0.27rem;text-align: left;"
          >为了更好的对接您的订单和需求，请认真选择！</div>
          <div class="van-hairline--surround">
            <van-field
              v-model="resObj.month_invoice"
              required
              :rules="[{ required: true, message: '请选择当月订单是否当月开具发票' }]"
              :border="false"
              readonly
              :err="rule.month_invoice"
              clickable
            >
              <template #input>
                <select class="selectCss" v-model="resObj.month_invoice" style="padding-left: 5px;">
                  <option value="" disabled hidden>请选择当月订单是否当月开具发票</option>
                  <option value="1">是</option>
                  <option value="2">否</option>
                </select>
              </template>
            </van-field>
          </div>
          <div class="code-box">
            <div class="van-hairline--surround">
              <van-field
                v-model="resObj.code"
                clearable
                :error="rule.code"
                required
                placeholder="请输入验证码"
                @blur="
                  e => {
                    ;/^\d{6}$/.test(resObj.code) ? (rule.code = false) : (rule.code = true)
                  }
                "
              >
                <template slot="left-icon">
                  <img src="@/assets/signUp/icons_tip.png" alt>
                </template>
              </van-field>
            </div>
            <!-- <div class="van-hairline--surround get-code">
              获取验证码
            </div>-->
            <van-button type="info" class="get-code" :disabled="num != 0" @click="getPhoneCode">
              {{
              num > 0 ? `${num}s` : "获取验证码"
              }}
            </van-button>
          </div>
          <awsc
            v-if="ic_register_show && is_skip === 2 && resFlag"
            :index="index"
            ref="awscWrap"
            :seleced.sync="captchaVerifyParam"
          ></awsc>
          <!-- <div>滑块验证</div> -->
          <div class="choose-box">
            <div>
              <!-- 忘记密码? -->
            </div>
            <a
              style="color:#1890FF"
              @click="
                () => {
                  this.loginFlg = true
                  this.resFlag = false
                  this.tit_tip = 'S2BDIY供应链登录'
                }
              "
            >已有账号?登录</a>
          </div>
          <div class="sumbit">
            <van-button @click="registerUser">注册</van-button>
          </div>
          <div class="agreement">
            注册即默认同意
            <span
              style="color:#1890FF"
              @click="
                $router.push('/clause')
                show = false
              "
            >《平台系统用户协议》</span>
          </div>
        </div>
        <!-- 登录 -->
        <div class="login-box" v-show="loginFlg">
          <div class="van-hairline--surround">
            <van-field
              v-model="loginObj.username"
              clearable
              :error="rule.loginUser"
              required
              placeholder="用户名"
              @blur="
                e => {
                  e.target.value.length < 6 ? (rule.loginUser = true) : (rule.loginUser = false)
                }
              "
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_user.png" alt>
              </template>
            </van-field>
          </div>
          <div class="van-hairline--surround">
            <van-field
              v-model="loginObj.password"
              clearable
              placeholder="请输入密码"
              type="password"
              :error="rule.loginPsw"
              required
              @blur="
                e => {
                  e.target.value.length < 6 ? (rule.loginPsw = true) : (rule.loginPsw = false)
                }
              "
            >
              <template slot="left-icon">
                <img src="@/assets/signUp/icons_psw.png" alt>
              </template>
            </van-field>
          </div>
          <!-- <div>滑块验证</div> -->
          <awsc
            v-if="ic_login_show && is_skip === 2 && loginFlg"
            :index="index"
            ref="awscWrap"
            :seleced.sync="captchaVerifyParam"
          ></awsc>
          <div class="choose-box">
            <div>
              <!-- 忘记密码? -->
            </div>
            <div
              style="color:#1890FF"
              @click="
                () => {
                  this.loginFlg = false
                  this.resFlag = true
                  this.tit_tip = 'S2BDIY供应链注册'
                }
              "
            >注册</div>
          </div>
          <div class="sumbit">
            <van-button @click="getUser">登录</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <van-notify v-model="errShow" type="success" class="errTip">
      <div>
        <img src="@/assets/signUp/errX.png">
        {{ errMessage }}
      </div>
      <img
        src="@/assets/signUp/iconX.png"
        @click="
          () => {
            errShow = false
          }
        "
      >
    </van-notify>
    <iframe ref="iframe" style="display:none"></iframe>
  </div>
</template>
<script>
import awsc from "./awsc.vue"
import "./index.less"
import { phoneCode, register, loginUser } from "@/api/register"
import { mapMutations, mapState } from "vuex"
import { registerSource } from "@/utils/const"
export default {
  components: { awsc },
  name: "register",
  data() {
    return {
      register_source: "",
      register_source_detail: "",
      product_type: "",
      is_skip: 2,
      index: 1,
      tit_tip: "S2BDIY账号注册",
      resFlag: true,
      loginFlg: false,
      show: false,
      errShow: false,
      registerSource: registerSource,
      resObj: {
        username: "",
        password: "",
        password_confirmation: "",
        phone: "",
        code: "",
        month_invoice: ""
      },
      loginObj: {
        username: "",
        password: ""
      },
      rule: {
        user: false,
        psw: false,
        psw2: false,
        phone: false,
        code: false,
        loginUser: false,
        loginPsw: false,
        month_invoice: false
      },
      token: "",
      ic_login_show: true,
      captchaVerifyParam: '',
      ic_register_show: true,
      num: 0,
      intervalFlag: "",
      errMessage: ""
    }
  },
  computed: {
    ...mapState({
      path: state => state.register.path
    })
  },
  watch: {
    num: {
      handler() {
        if (this.num == 0) {
          clearInterval(this.intervalFlag)
          this.intervalFlag = null
        }
      },
      deep: true
    },
    errShow(value) {
      if (value) {
        setTimeout(() => {
          this.errShow = false
        }, 1000)
      }
    }
  },

  methods: {
    ...mapMutations({
      setToken: "SET_TOKEN",
      setToPath: "SET_TO_PATH"
    }),
    resetAwsc() {
      const { awscWrap } = this.$refs
      this.captchaVerifyParam = ''
      if (awscWrap) {
        awscWrap.awscFn()
      }
    },
    changeSource() {
      this.register_source_detail = ""
    },
    shareToken(token) {
      return new Promise(res => {
        const { iframe } = this.$refs
        iframe.src = "https://www.s2bdiy.com/"
        iframe.onload = () => {
          iframe.contentWindow.postMessage({ token }, "https://www.s2bdiy.com/")
          res(123)
        }
      })
    },
    countDown() {
      this.intervalFlag = setInterval(() => {
        this.num--
        console.log(this.num)
      }, 1000)
    },
    getPhoneCode() {
      if (this.rule.phone || this.resObj.phone == "") {
        this.errMess("手机输入有误")
        return
      }
      this.num = 60
      this.countDown()
      phoneCode({
        phone: this.resObj.phone,
        type: 1
      })
    },
    registerUser() {
      const rule = this.rule
      const resObj = this.resObj
      console.log("resObj===", resObj)
      console.log("rule===", rule)
      if (rule.user || resObj.username == "") {
        this.errMess("输入至少6位数用户信息")
        return
      } else if (rule.psw || resObj.password == "") {
        this.errMess("输入至少6位数登录密码")
        return
      } else if (rule.psw2 || resObj.password_confirmation == "") {
        this.errMess("用户确认密码不一致")
        return
      } else if( rule.month_invoice || resObj.month_invoice == '') {
        this.errMess("请选择当月订单是否当月开具发票")
        return
      } else if (rule.phone || resObj.phone == "") {
        this.errMess("联系电话输入有误")
        return
      } else if (rule.code || resObj.code == "") {
        this.errMess("验证码输入有误")
        return
      } else if (!this.captchaVerifyParam) {
        this.errMess("请先人机验证")
        return
      } else if (!this.register_source) {
        this.errMess("请来源渠道")
        return
      } else if (!this.product_type) {
        this.errMess("请选择关注的产品")
        return
      } 
      if (this.register_source === 13 && !this.register_source_detail) {
        this.errMess("请输入其他来源渠道")
        return
      }
      const obj = {
        CaptchaVerifyParam: this.captchaVerifyParam,
        register_source_detail: this.register_source === 13 ? this.register_source_detail : "",
        register_source: this.register_source,
        product_type: this.product_type,
        ...resObj
      }
      if (this.$route.query.token) {
        obj.share_token = this.$route.query.token
      }
      register(obj)
        .then(() => {
          this.init()
        })
        .catch(err => {
          this.errMess(err.msg)
          this.resetAwsc()
        })
    },
    getUser() {
      const rule = this.rule
      const loginObj = this.loginObj
      if (rule.loginUser || loginObj.username == "") {
        this.errMess("用户信息至少为6位")
        return
      } else if (rule.loginPsw || loginObj.password == "") {
        this.errMess("用户密码至少为6位")
        return
      } else if (!this.captchaVerifyParam) {
        this.errMess("请先人机验证")
        return
      }
      loginUser({
        CaptchaVerifyParam: this.captchaVerifyParam,
        ...this.loginObj
      })
        .then(res => {
          this.setToken(res.token)
          this.init()
          this.show = false
          if (this.path) {
            this.$router.push(this.path)
          }
          this.setToPath("/views/main")
          // this.shareToken(res.token).then(res => {
          //   console.log(res)
          //   window.open("https://www.s2bdiy.com/")
          // })
        })
        .catch(() => {
          this.resetAwsc()
        })
    },
    errMess(Message) {
      this.errMessage = Message
      this.errShow = true
    },
    init() {
      this.resObj.username = ""
      this.resObj.password = ""
      this.resObj.password_confirmation = ""
      this.resObj.phone = ""
      this.resObj.code = ""
      this.loginObj.username = ""
      this.loginObj.password = ""
    }
  },
  created() {},
  mounted() {}
}
</script>

<style scoped lang="less">
.loginCss {
  z-index: 2300 !important;
}
.van-popup {
  border-radius: 4px;
  .signUpBox {
    width: 280px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #eeeeee;
    padding: 0 20px;
    .close-icon {
      width: 16px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .box-title {
      // width: 160px;
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #1890ff;
      line-height: 25px;
      margin: 20px auto 10px;
      text-align: center;
    }
    .line {
      width: 250px;
      height: 1px;
      background: #eeeeee;
      margin: auto;
    }

    .choose-box {
      margin-top: 15px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }
    .van-hairline--surround {
      // width: 240px;
      margin: 10px auto 0;
      background: #fefefe;
      // border-radius: 6px;
      // border: 1px solid #d9d9d9;
      img {
        width: 16px;
        // padding-right: 10px;
        padding-top: 14px;
      }
      .van-cell {
        background: transparent !important;
        display: flex;
        align-items: center;
        height: 40px;
        line-height: 40px;
      }
      .selectCss {
        display: block;
        width: 100%;
        padding: 0 20px;
        border: none;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        color: #333;
        outline: none;
        background: transparent;
        &:focus,
        &:focus-visible {
          border: none;
          background: transparent;
        }
      }
    }
    .van-hairline--surround::after {
      border-radius: 10px;
    }
    .register-box {
      .code-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 10px 0px 0 0;
        img {
          padding-right: 9px;
        }
        .van-hairline--surround {
          width: 142px;
          margin-top: 0;
          margin-left: 0;
        }
        .get-code {
          text-align: center;
          line-height: 37px;
          color: #fff;
          font-size: 12px;
          // width: 85px;
          height: 37px;
          background: #1890ff;
          border-radius: 5px;
          padding: 0 12px 0 13px;
          .van-button__text {
            font-size: 12px;
          }
        }
      }
    }
    .login-box {
      margin-top: 31px;
      .sumbit {
        margin-bottom: 30px;
      }
    }
    .firstInput {
      margin-top: 20px;
    }
    .agreement {
      font-size: 12px;
      text-align: center;
      margin: 15px 0 13px 0;
    }
    .sumbit {
      display: flex;
      justify-content: center;
      margin-top: 15px;
    }
  }
}
.errTip {
  background: #fff1f0;
  border-radius: 4px;
  border: 1px solid #ffa39e;
  height: 40px;
  width: 335px;
  margin-left: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  img {
    width: 12px;
    padding-left: 16px;
  }
  div {
    width: 259px;
    height: 22px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    padding-left: 4px;
  }
}
</style>
